import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // 1. Immediate scroll to top
    // We force behavior: 'auto' (or instant) to skip any 'scroll-behavior: smooth' in CSS
    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    } catch (e) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }

    // 2. Delayed fallback scroll
    // This handles cases where layout shifts or animations happen shortly after route change
    // which can sometimes 'pull' the scroll position back down
    const timeoutId = setTimeout(() => {
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto",
        });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }, 50); // 50ms is usually enough to catch the start of most layout shifts

    return () => clearTimeout(timeoutId);
  }, [pathname, location.search]); // Run on path AND query param changes (important for Shop filters)

  return null;
}
